import GQL from "../gql/gql";
import Html from "./html";

class Joke {

    constructor(
        private html: Html,
        private gql: GQL
    ) { }

    voteUp(jokeId: number): void {
        this.gql.jokeVoteUp(jokeId)
            .then(r => this.afterVote(jokeId, r, 'up'));
    }

    voteDown(jokeId: number): void {
        this.gql.jokeVoteDown(jokeId)
            .then(r => this.afterVote(jokeId, r, 'down'))
    }

    toggleJokeText(id: string): void {
        this.html.toggleClass(id, 'joke-open');
    }

    private afterVote(jokeId: number, r: any, direction: string): void {
        // Increase vote count
        const cssCass = direction === 'up' ? '.joke-likes-positive' : '.joke-likes-negative';
        const selector = '#joke_' + jokeId + ' ' + cssCass;

        const e = this.html.q(selector);

        if (!e) {
            return;
        }

        const nbVotes = r.jokeVote?.count + 1;

        this.html.writeHTML(selector, '' + nbVotes);
    }
}

export default Joke;